import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { contactsApi } from '@/api/contacts.api';
import { extractErrorMessage } from '@/lib/errors';

export function useContactsList(params?: { page?: number; pageSize?: number; search?: string }) {
  return useQuery({
    queryKey: ['contacts', params],
    queryFn: () => contactsApi.list(params),
    select: (res) => res.data,
  });
}

export function useCreateContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: contactsApi.create,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['contacts'] });
      toast.success('Contato criado');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}

export function useUpdateContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof contactsApi.update>[1] }) =>
      contactsApi.update(id, data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['contacts'] });
      toast.success('Contato atualizado');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}

export function useDeleteContact() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: contactsApi.delete,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['contacts'] });
      toast.success('Contato removido');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}

export function useImportContacts() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: contactsApi.importCsv,
    onSuccess: (res) => {
      void qc.invalidateQueries({ queryKey: ['contacts'] });
      const { created, skipped } = res.data.data;
      toast.success(`Importados: ${created} novos, ${skipped} já existentes`);
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}
